module.exports = __webpack_public_path__ + "static/media/intro.769cd1ed.mp3";